var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralRefreshPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.085,
    height: 150.086,
    viewBox: "0 0 150.085 150.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.127,
    y1: 0.072,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#c872fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#730eb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#a032eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffefa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.127,
    y1: 0.072,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#c872fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#6800ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#921de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffefa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26179",
    "data-name": "Group 26179",
    transform: "translate(-289.07 -142.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_19188",
    "data-name": "Path 19188",
    transform: "translate(289.071 142.718)",
    opacity: 0.933
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19188-2",
    "data-name": "Path 19188",
    d: "M268.977,343.234A73.919,73.919,0,1,0,342.9,417.153,74,74,0,0,0,268.977,343.234Zm0,0",
    transform: "translate(-193.935 -342.11)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19188_-_Outline",
    "data-name": "Path 19188 - Outline",
    d: "M269.851,493.07a75.043,75.043,0,1,1,75.042-75.043A75.128,75.128,0,0,1,269.851,493.07Zm0-147.838a72.8,72.8,0,1,0,72.795,72.8A72.877,72.877,0,0,0,269.851,345.232Z",
    transform: "translate(-194.809 -342.984)",
    fill: "rgba(200,124,255,0.69)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M268.977,343.234A73.919,73.919,0,1,0,342.9,417.153,74,74,0,0,0,268.977,343.234Zm0,0",
    transform: "translate(95.135 -199.392)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206_-_Outline",
    "data-name": "Path 206 - Outline",
    d: "M269.851,493.07a75.043,75.043,0,1,1,75.042-75.043A75.128,75.128,0,0,1,269.851,493.07Zm0-147.838a72.8,72.8,0,1,0,72.795,72.8A72.877,72.877,0,0,0,269.851,345.232Z",
    transform: "translate(94.261 -200.266)",
    fill: "rgba(200,124,255,0.69)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(324.045 181.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M76.767,49.222h-4.9A35.592,35.592,0,0,0,11.025,23.9,35.552,35.552,0,0,0,.011,49.222H0l.006.1L0,49.449H.011a35.841,35.841,0,0,0,35.607,35.8,35.384,35.384,0,0,0,25.2-10.525L52.83,67.017A24.488,24.488,0,1,1,19.014,31.6a24.434,24.434,0,0,1,41.7,17.585v.039H55.87c-3,0-4.225,2.009-2.725,4.454L63.593,64.011c2.39,2.39,3.081,2.368,5.455,0L79.495,53.677C81,51.225,79.768,49.222,76.767,49.222Z",
    transform: "translate(0 -13.394)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralRefreshPurple);
export default __webpack_public_path__ + "static/media/general-refresh-purple.5c5c2b4e8b6a655364b92289539c1b4d.svg";
export { ForwardRef as ReactComponent };